import { Location } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { EduButtonComponent } from '@atoms/button/button.component';
import { CardComponent } from '@atoms/card/card.component';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { SharedCommonModule } from '@shared/common.module';
import { openContactPage } from '@helpers/support';

@Component({
  selector: 'edu-error',
  templateUrl: './error.component.html',
  imports: [SharedCommonModule, EduIconComponent, EduButtonComponent, CardComponent],
})
export class ErrorComponent {
  public WarningIcon = Icons.WARNING;
  private location = inject(Location);
  private router = inject(Router);

  /** Rendered text, already translated. Falls back to a generic message when empty. */
  public header = input<string>('');
  /** Rendered text, already translated. Falls back to a generic message when empty. */
  public description = input<string>('');
  public isGoBackButtonVisible = input<boolean>(true);

  goToHomepage(): void {
    this.router.navigate(['/']);
  }

  goBack(): void {
    this.location.back();
  }

  contactSupport() {
    openContactPage();
  }
}
